<script setup lang="ts">
import { SancareOcticon } from '@sancare/typescript-commons'
import dayjs from 'dayjs'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { SmrStay } from '@/store/modules/stay/smr/types'
import { Stay, ValidationTypeEnum } from '@/store/modules/stay/types'

const { t } = useI18n()

const props = defineProps<{
  stay: Stay | SmrStay
}>()

const automationLabelKeys: Partial<Record<ValidationTypeEnum, string>> = {
  [ValidationTypeEnum.AUTOMATION_AI]: 'stayDisplayer.validatedByAutomationAi',
  [ValidationTypeEnum.AUTOMATION_RULES]: 'stayDisplayer.validatedByAutomationRules',
  [ValidationTypeEnum.RECONDUCTION]: 'stayDisplayer.validatedByReconduction',
}

const validatedOn = computed<string | null>(() => {
  if (!props.stay.validationDate) {
    return null
  }
  const d = dayjs(props.stay.validationDate)
  return t('stayDisplayer.validatedOn', { date: d.format('DD/MM/YYYY'), time: d.format('HH:mm') })
})

const validatedBy = computed<string | null>(() => {
  if ('validationType' in props.stay && props.stay.validationType) {
    const labelKey = automationLabelKeys[props.stay.validationType]
    if (labelKey) {
      return t(labelKey, { group: props.stay.validatedGroupName })
    }
  }

  if (!props.stay.validationUser) {
    return null
  }

  return props.stay.validationUser.sancareUser
    ? 'Sancare'
    : `${props.stay.validationUser.firstName} ${props.stay.validationUser.lastName}`
})
</script>

<template>
  <div class="grouping-card__validation-info">
    <sancare-octicon
      name="check"
      :width="16"
      :height="16"
    />
    <span>{{ t('stayDisplayer.validatedStay', { validatedOn, validatedBy }) }}</span>
  </div>
</template>
